<app-q1-feedback-layout>
  <div class="wrap">
    <img class="icon" src="/assets/img/game/danger-pink.svg">
    <div class="text-wrap">
      <div>Good job.</div>
      <div>You've selected <span class="pink">{{ correctSelections }}</span> out of the 20 ideal stores to focus on for this simulation. Have another go, and consider these points:</div>
    </div>
    <div class="info-helpers">
      <app-q1-feedback-retailer-tile
        *ngFor="let shop of incorrectShops"
        [shopId]="shop.id"
        [feedback]="shop.feedback"
        (infoClicked)="onNavigateToSlider($event)"
      ></app-q1-feedback-retailer-tile>
    </div>
    <div class="text-wrap">
      <div class="pink">Please try again and submit selection.</div>
    </div>
    <app-button
      [text]="'Try again'"
      (click)="onContinueClick()"
    ></app-button>
  </div>
</app-q1-feedback-layout>
